import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "hooks";
import {
	onOpenPopUpV2,
	onClosePopUpV2,
	onCloseAllPopUpsV2,
	onReplaceAllPopUpsV2,
	selectPopUpManagerV2State
} from "redux/slices";
import {
	OpenPopUpPayload,
	ClosePopUpPayload
} from "redux/slices/pop-up-manager-v2/types";
import { PopUpVariant } from "interfaces";

export const usePopUpsV2 = () => {
	const dispatch = useAppDispatch();
	const state = useAppSelector(selectPopUpManagerV2State);

	const open = useCallback(
		(payload: OpenPopUpPayload) => dispatch(onOpenPopUpV2(payload)),
		[dispatch]
	);
	const close = useCallback(
		(payload?: ClosePopUpPayload) => dispatch(onClosePopUpV2(payload)),
		[dispatch]
	);
	const closeAll = useCallback(
		() => dispatch(onCloseAllPopUpsV2()),
		[dispatch]
	);
	const replaceAll = useCallback(
		(variants: PopUpVariant[]) => dispatch(onReplaceAllPopUpsV2(variants)),
		[dispatch]
	);

	return {
		stack: state.stack,
		open,
		close,
		closeAll,
		replaceAll
	};
};

export default usePopUpsV2;
